import React, { useEffect, useState } from "react";
import AdaptiveDateRangePicker from "app/components/AdaptiveDateRangePicker";
import StatusSelectionButton from "./StatusSelectionButton";
import { CalendarIcon } from "app/components/Icons";
import { format } from "date-fns/format";
import AdaptiveDatePicker from "app/components/AdaptiveDatePicker";

interface DueDateSelectionProps {
  dueDate?: string;
  endDate?: string;
  onDateChange?: (val?: string) => void;
}

const DueDateSelection: React.FC<DueDateSelectionProps> = ({
  dueDate,
  onDateChange,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleChange = (val) => {
    setSelectedDate(val);
    if (onDateChange) {
      onDateChange(val.toISOString());
    }
  };
  return (
    <>
      <AdaptiveDatePicker
        value={selectedDate}
        onChange={(v) => {
          handleChange(v);
        }}
        trigger={
          <button className="flex items-center justify-between w-full px-2 py-2 rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <StatusSelectionButton
              label="Due date:"
              selectedLabel={
                selectedDate ? format(selectedDate, "dd MMM, yyyy") : "-"
              }
              icon={<CalendarIcon size={20} color="#79808A" />}
              className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
            />
          </button>
        }
      />
    </>
  );
};

export default DueDateSelection;
